'use strict'

export default {
  computed: {
    store () {
      return this.$store.state.process.batChampionship
    },

    storeResponse () {
      return this.store.response
    },

    storeResponseData () {
      return this.storeResponse ? this.storeResponse.data : null
    },

    storeResponseDataBatChampionship () {
      return this.storeResponseData ? this.storeResponseData['bat-championship'] : null
    }
  }
}
